module.exports = __webpack_public_path__ + "img/52114139_L.3fdb25c6.png";